import type { RefObject } from 'react';
import type { CtaRefType } from 'util/cta/cta.data';
import { fadeFromTo, fadeTo } from 'util/animation/fade/fade';

interface IconButtonRefs {
  elementRef: RefObject<CtaRefType | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: IconButtonRefs,
): void {
  timeline.fromTo(
    elementRef.current,
    { scale: 0.4 },
    { duration: 0.5, scale: 1, ease: 'Expo.easeOut', clearProps: 'scale' },
    0,
  );
  timeline.add(fadeFromTo(elementRef.current as HTMLElement), 0);
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: IconButtonRefs,
): void {
  timeline.add(
    fadeTo(elementRef.current as HTMLElement, {
      duration: 0.4,
      ease: 'Expo.easeOut',
    }),
  );
  timeline.to(elementRef.current, { duration: 0.4, scale: 0.4, ease: 'Expo.easeOut' }, 0);
}
